import { BroadcastChannel } from "broadcast-channel";

export const BroadCastTabController = {
    getNewBroadCast: (): BroadcastChannel => {
        const checkoutBroadCast = new BroadcastChannel("checkoutBroadCast")
        return checkoutBroadCast
    }
}